import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    firstName: {
      validations: []
    },
    lastName: {
      validations: []
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    clientname: {
      validations: []
    },
    eventextra1: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    StartTime: {
      validations: []
    },
    theme: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    notes: {
      validations: []
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email',
            mapping: 'email',
            customClasses: ['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name',
            mapping: 'firstName',
            customClasses: ['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name',
            mapping: 'lastName',
            customClasses: ['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number',
            mapping: 'telNumber',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company',
            mapping: 'clientname',
            customClasses: ['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice-nolabel',
            size: 'XLarge',
            label: 'Which space are you interested in?',
            options: [
              { label: 'Agave Bar', value: 'Agave Bar' },
              { label: 'Fronterra Room', value: 'Fronterra Room' },
              { label: 'Mezzanine', value: 'Mezzanine' },
              { label: 'Outdoor Garden Lounge', value: 'Outdoor Garden Lounge' },
            ],
            mapping: 'eventextra1',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date',
            mapping: 'eventDate',
            customClasses: ['no-label']
      },
      {
            type: 'multiple-choice-nolabel',
            size: 'Medium',
            label: 'Time',
            options: [
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM (next day)', value: '00:00:00' },
              { label: '12:30 AM (next day)', value: '00:30:00' },
              { label: '1:00 AM (next day)', value: '01:00:00' },
              { label: '1:30 AM (next day)', value: '01:30:00' },
              { label: '2:00 AM (next day)', value: '02:00:00' },
              { label: '2:30 AM (next day)', value: '02:30:00' }
            ],
            mapping: 'StartTime',
            customClasses: ['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice-nolabel',
            size: 'XLarge',
            label: 'Type of Event',
            options: [
              { label: 'Alumni', value: 'Alumni'},
              { label: 'Bachelor/Bachelorette', value: 'Bachelor/Bachelorette' },
              { label: 'Birthday', value: 'Birthday' },
              { label: 'Cocktail Reception', value: 'Cocktail Reception' },
              { label: 'Corporate Lunch', value: 'Corporate Lunch' },
              { label: 'Engagement', value: 'Engagement' },
              { label: 'Fundraiser', value: 'Fundraiser' },
              { label: 'Graduation', value: 'Graduation' },
              { label: 'Holiday', value: 'Holiday' },
              { label: 'Meeting/Presentation', value: 'Meeting/Presentation' },
              { label: 'Photo/Film Shoot', value: 'Photo/Film Shoot' },
              { label: 'Private Dinner', value: 'Private Dinner' },
              { label: 'Rehearsal Dinner', value: 'Rehearsal Dinner' },
              { label: 'Shower', value: 'Shower' },
              { label: 'Sporting Event', value: 'Sporting Event' },
              { label: 'Wedding', value: 'Wedding' },
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'theme',
            customClasses: ['no-label']
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Number of People',
            mapping: 'plannedguestcount',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Additional Information',
            mapping: 'notes',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Poca Madre Contact Form',
    formId: '629',
    clientKey: '593E0988-3B32-4DE6-8326-39F94779AB9F',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/tacobamba2/form_structure.js